import _defineProperty from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["className", "value", "defaultValue", "valueChange", "showPlusMinus", "suffixText", "prefixText", "disabled", "min", "max", "isInteger", "convertToString", "error", "errMessage"],
    _excluded2 = ["name", "control", "rules", "defaultValue", "containerClassName"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { forwardRef, useState } from 'react';
import { Add, Remove } from '@mui/icons-material';
import { Box, FormHelperText, IconButton, TextField } from '@mui/material';
import { styled } from '@mui/system';
import clsx from 'clsx';
import { useController } from 'react-hook-form';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var StyledTextField = styled(TextField)(function (_ref) {
  var theme = _ref.theme;
  return {
    '& input[type=number]': {
      MozAppearance: 'textfield',
      // Firefox
      '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
        // Chrome, Safari, Edge
        WebkitAppearance: 'none',
        margin: 0
      },
      textAlign: 'center'
    },
    '.MuiInputBase-root': {
      'input:focus': {
        boxShadow: 'none'
      }
    }
  };
});
var JoveManualAddNumber = /*#__PURE__*/forwardRef(function (props, ref) {
  var className = props.className,
      value = props.value,
      defaultValue = props.defaultValue,
      valueChange = props.valueChange,
      showPlusMinus = props.showPlusMinus,
      suffixText = props.suffixText,
      prefixText = props.prefixText,
      disabled = props.disabled,
      min = props.min,
      max = props.max,
      isInteger = props.isInteger,
      convertToString = props.convertToString,
      error = props.error,
      errMessage = props.errMessage,
      rest = _objectWithoutProperties(props, _excluded);

  var _useState = useState(String(defaultValue || '')),
      selectValue = _useState[0],
      setSelectValue = _useState[1];
  /**
   * methods
   */


  var numberChangeAction = function numberChangeAction(e) {
    var value = e.target.value;

    if (value !== '') {
      if (min !== undefined) {
        if (Number(value) < Number(min)) {
          value = String(min);
        }
      }

      if (max !== undefined) {
        if (Number(value) > Number(max)) {
          value = String(max);
        }
      }

      if (isInteger) {
        value = String(parseInt(value));
      }

      if (!convertToString) {
        value = Number(value);
      }
    }

    setSelectValue(value);
    valueChange === null || valueChange === void 0 ? void 0 : valueChange(value);
  };

  var plusAction = function plusAction() {
    var tempValue = value === undefined ? selectValue : value;
    var count = Number(tempValue || 0);
    numberChangeAction({
      target: {
        value: count + 1
      }
    });
  };

  var subtractAction = function subtractAction() {
    var tempValue = value === undefined ? selectValue : value;
    var count = Number(tempValue || 0);
    numberChangeAction({
      target: {
        value: count === 0 ? 0 : count - 1
      }
    });
  };

  var realValue = value === undefined ? selectValue : value !== null && value !== void 0 ? value : '';
  return /*#__PURE__*/_jsxs(Box, {
    className: clsx('flex flex-col', className),
    children: [/*#__PURE__*/_jsxs(Box, {
      className: "flex w-full flex-row items-center space-x-2",
      children: [/*#__PURE__*/_jsx(Box, {
        className: "flex h-14 w-14 items-center justify-center overflow-hidden rounded-full border border-[#e5e7eb]",
        children: /*#__PURE__*/_jsx(IconButton, {
          className: "h-full w-full",
          onClick: subtractAction,
          disabled: realValue === min,
          children: /*#__PURE__*/_jsx(Remove, {})
        })
      }), /*#__PURE__*/_jsx(StyledTextField, _objectSpread(_objectSpread({}, rest), {}, {
        className: "flex-1",
        type: "number",
        value: realValue,
        onChange: numberChangeAction
      })), /*#__PURE__*/_jsx(Box, {
        className: "flex h-14 w-14 items-center justify-center overflow-hidden rounded-full border border-[#e5e7eb]",
        children: /*#__PURE__*/_jsx(IconButton, {
          className: "h-full w-full",
          onClick: plusAction,
          disabled: realValue === max,
          children: /*#__PURE__*/_jsx(Add, {})
        })
      })]
    }), error && /*#__PURE__*/_jsx(FormHelperText, {
      error: error,
      children: errMessage
    })]
  });
});
export var JoveManualAddNumberControlled = /*#__PURE__*/forwardRef(function (props, ref) {
  var name = props.name,
      control = props.control,
      rules = props.rules,
      defaultValue = props.defaultValue,
      containerClassName = props.containerClassName,
      rest = _objectWithoutProperties(props, _excluded2);

  var _useController = useController({
    name: name,
    control: control,
    rules: rules,
    defaultValue: defaultValue
  }),
      _useController$field = _useController.field,
      value = _useController$field.value,
      onChange = _useController$field.onChange,
      error = _useController.fieldState.error;

  return /*#__PURE__*/_jsx(Box, {
    className: clsx('flex flex-col', containerClassName),
    children: /*#__PURE__*/_jsx(JoveManualAddNumber, _objectSpread(_objectSpread({}, rest), {}, {
      ref: ref,
      value: value,
      valueChange: onChange,
      defaultValue: defaultValue,
      error: !!error,
      errMessage: error === null || error === void 0 ? void 0 : error.message
    }))
  });
});
export default JoveManualAddNumber;